







import { Component, Vue, Prop } from 'vue-property-decorator';
import ProjectsList from '@/components/ProjectsList.vue';
import NotLoggedPanel from '@/components/NotLoggedPanel.vue';
import { User } from '@/models/user';

@Component({
    name: 'Projects',
    components: {
        ProjectsList,
        NotLoggedPanel
    }
})
export default class Projects extends Vue {
    @Prop() private user!: User;
}
